export class HighFrequencyBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<HighFrequencyBackupResourceType>",
            "format": ""
        },
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<HighFrequencyBackupSchedules>",
            "format": ""
        },
        {
            "name": "scheduleTimezone",
            "baseName": "scheduleTimezone",
            "type": "ScheduleTimezone",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return HighFrequencyBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
